import { Professional, ProfessionalFormationTypeEnum } from '@medprev-web-app/api-graphql-client';

import {
  ProfessionalFormationTypeTranslationMap,
} from '@/types/professional/professional.type';
import { hasAnyLicenseWithCRM } from '@/utils/professional/professional-license.util';
import { POST_GRADUATION_FORMATION_TYPES } from '@/utils/professional/main-post-graduation.util';

const NON_SPECIALIST_MARKER = '(NÃO ESPECIALISTA)';

type FormationWithMetadata = {
  formattedString: string;
  completionYear: number | null;
  isOther: boolean;
};

function compareFormations(a: FormationWithMetadata, b: FormationWithMetadata): number {
  if (a.isOther !== b.isOther) {
    return a.isOther ? 1 : -1;
  }

  if (a.completionYear !== null && b.completionYear !== null) {
    return b.completionYear - a.completionYear;
  }

  if (a.completionYear !== null) {
    return -1;
  }
  if (b.completionYear !== null) {
    return 1;
  }

  return 0;
}

export function formatProfessionalFormations(professional: Professional): string[] {
  const formations = professional.professionalFormations ?? [];
  const hasCrm = hasAnyLicenseWithCRM(professional);

  return formations
    .map((formation) => {
      const { description, location, completionYear, type } = formation;
      const parsedYear = completionYear ? Number(completionYear) : null;
      const translatedType = type ? ProfessionalFormationTypeTranslationMap[type] ?? '' : '';
      const isOther = type === ProfessionalFormationTypeEnum.Other;
      const safeDescription = description ?? '';

      let formattedString = '';

      if (isOther || !translatedType) {
        formattedString = safeDescription;
      } else {
        formattedString = `${translatedType} em ${safeDescription}`;
      }

      if (hasCrm && type && POST_GRADUATION_FORMATION_TYPES.includes(type)) {
        formattedString += ` ${NON_SPECIALIST_MARKER}`;
      }

      if (location) {
        formattedString += ` - ${location}`;
      }

      if (parsedYear !== null) {
        formattedString += ` (${parsedYear})`;
      }

      return {
        formattedString,
        completionYear: parsedYear,
        isOther,
      };
    })
    .sort(compareFormations)
    .map((formation) => formation.formattedString);
}

export function formatProfessionalLanguages(professional: Professional): string[] {
  return (professional.languageAndAccessibility ?? []).map((language) => language);
}

export function formatProfessionalTreatments(professional: Professional): string[] {
  return (professional.treatments ?? []).map((treatment) => treatment);
}
